import Kanyi from "./images/kanyi_mwangi.jpg"
import Rita from "./images/rita_njeri.jpg"
import Devesa from "./images/devesa_neto.jpg"
import Rochelle from "./images/rochelle_halim.jpg"
import Lara from "./images/lara_randle.jpg"
import Salma from "./images/salma_ettamen.jpg"

export const content = [
  {
    "firstName": "Kanyi",
    "lastName": "Mwangi",
    "title": "Director, Communications, East and West Africa",
    "imageSrc": Kanyi,
    "questionArray": [
      "What does “She is Priceless” mean to you?",
      "How has being a woman shaped your leadership style?",
      "What does this year’s IWD theme, “Accelerate Action,” mean to you?",
      "What inspired you to step into your current role, and how has it transformed your perspective?",
      "Do you have a personal mantra?"
    ],
    "responseArray": [
      "<p>It embodies the valuable, unique, and impactful qualities women bring to every table they sit at and the positive impact they create around them.</p>",
      "<p>Leading with my heart, mind, and instinct has proven invaluable—my heart fuels my passion for work and reflects my emotional side as a leader, my intellect drives rationality and strategy, and my intuition guides insightful decisions.</p>",
      "<p>It calls for faster progress towards gender equality. In my role, it’s exemplified by celebrating women’s achievements through initiatives like She Is Priceless to highlight leadership lessons and the importance of our DEI efforts at Mastercard.</p>",
      "<p>What drew me to this role was the opportunity to tell powerful stories. I've always been passionate about communication's ability to connect people and drive positive change. Stepping into this role has given me a broader perspective on the power of technology to empower communities.</p>",
      "<p>Be your authentic self – the key to being our best selves lies in staying true to who we are.</p>"
    ]
  },
  {
    "firstName": "Rita",
    "lastName": "Njeri",
    "title": "Director, Customer Solutions Centre, East and West Africa",
    "imageSrc": Rita,
    "questionArray": [
      "What does “She is Priceless” mean to you?",
      "What are some unique challenges you’ve faced as a woman in tech, and how did they shape your resilience?",
      "What does this year’s IWD theme, “Accelerate Action,” mean to you, and how do you practice it in your role?",
      "How do you define success in leadership, and what makes it “priceless” to you?",
      "What advice would you give to young women dreaming of a career in technology?"
    ],
    "responseArray": [
      "<p>To me, “She is Priceless” embodies the value women bring to every aspect of life— work, family, and community.</p>",
      "<p>Navigating biases and underrepresentation in tech was a challenge, but I was fortunate to be mentored by inspiring women who thrived in the industry.</p>",
      "<p>This is about executing plans and achieving results. The focus is on making measurable progress and influencing others to do the same.</p>",
      "<p>Success in leadership is about empowering others to reach their potential while staying grounded in your values.</p>",
      "<p>Learn by doing, and let curiosity be your compass. Build your own “kitchen table,” as Michelle Obama described, a supportive circle where you can exchange ideas and gain encouragement.</p>"
    ]
  },
  {
    "firstName": "Devesa",
    "lastName": "Neto",
    "title": "Country Business Development Director, Southern Africa – Emerging Markets",
    "imageSrc": Devesa,
    "questionArray": [
      "What does “She is Priceless” mean to you?",
      "What does this year’s IWD theme, “Accelerate Action,” mean to you, and how do you practice it in your role?",
      "When self-doubt arises, how do you overcome it and refocus on your goals?",
      "Balancing work and life can be tough—how do you stay grounded while excelling in your role?",
      "What’s one piece of advice you would pass on to the next generation of women leaders?"
    ],
    "responseArray": [
      "<p>‘She is Priceless’ represents the immeasurable value of a woman’s character, actions and positive influence.</p>",
      "<p>“Accelerate Action” is a call to move beyond words and take decisive, impactful actions toward progress.</p>",
      "<p>When self-doubt creeps in, I reflect on my past achievements and break down my goals into smaller, manageable steps.</p>",
      "<p>Staying grounded comes from prioritizing what truly matters and setting boundaries.</p>",
      "<p>Feel the fear and do it anyway. Every leader starts somewhere, and you belong here just as much as anyone else.</p>"
    ]
  },
  {
    "firstName": "Rochelle",
    "lastName": "Halim",
    "title": "Director, Customer Technical Services, South Africa",
    "imageSrc": Rochelle,
    "questionArray": [
      "What does “She is Priceless” mean to you?",
      "How has being a woman influenced your perspective and approach to leadership and your work?",
      "How do you handle self-doubt or moments of uncertainty in your career?",
      "What's one personal ritual or routine you never compromise on, even during busy work periods?",
      "What’s one lesson you wish you had learned earlier in your career?"
    ],
    "responseArray": [
      "<p>When I think of “She is Priceless,” I envision all the valuable, unnoticeable tasks a woman must execute.</p>",
      "<p>Being a woman has infused my leadership style with empathy and nurturing.</p>",
      "<p>Self-doubt often stems from a lack of knowledge, so I tackle it by asking questions and seeking clarity.</p>",
      "<p>Rest and recovery are non-negotiable. The mind needs downtime to process and perform effectively.</p>",
      "<p>Focus on people, not just the business. When people feel appreciated, they bring their best effort to the table.</p>"
    ]
  },
  {
    "firstName": "Lara",
    "lastName": "Randle",
    "title": "Director, Technology, Account Management, West Africa",
    "imageSrc": Lara,
    "questionArray": [
      "What does “She is Priceless” mean to you?",
      "What does this year’s IWD theme, “Accelerate Action,” mean to you, and how do you practice it in your role?",
      "How do you integrate ESG principles into your work, and why do they matter to you?",
      "What's one personal ritual or routine you never compromise on, even during busy work periods?",
      "How do you ensure time for yourself and loved ones amidst demanding responsibilities?"
    ],
    "responseArray": [
      "<p>‘She is Priceless’ recognizes women’s unique talents, aspirations, and the transformative experiences they contribute.</p>",
      "<p>‘Accelerate Action’ is about expediting the progress of women's equality through advocacy and mentorship.</p>",
      "<p>I incorporate ESG principles by supporting projects that enhance the accessibility and sustainability of digital transactions.</p>",
      "<p>I rely on the 1-3-5 rule to maintain productivity and stay grounded, prioritizing tasks effectively.</p>",
      "<p>Balancing responsibilities requires deliberate scheduling to ensure personal and professional priorities are met.</p>"
    ]
  },
  {
    "firstName": "Salma",
    "lastName": "Ettamen",
    "title": "Director, Solutions Architect, North Africa",
    "imageSrc": Salma,
    "questionArray": [
      "What does “She is Priceless” mean to you?",
      "How has being a woman influenced your perspective and approach to leadership and your work?",
      "Is there any woman leader who inspires you? What lessons have you drawn from their experiences?",
      "How do you balance the demands of senior leadership expectations while inspiring and managing your team?",
      "Do you have a personal mantra or guiding principle? How has it shaped your approach to work and life?"
    ],
    "responseArray": [
      "<p>‘She is Priceless’ celebrates the unique strength and contributions of women and their diverse journeys.</p>",
      "<p>Empathy and adaptability are key elements in my leadership, shaped by my experiences as a single mother and professional.</p>",
      "<p>Aïcha Chenna’s commitment to women's rights in Morocco has inspired me to advocate for change with resilience.</p>",
      "<p>Transparency, prioritization, and celebrating small wins help me navigate leadership challenges effectively.</p>",
      "<p>‘Resilience is growth in motion’ is my guiding principle, emphasizing perseverance and lifelong learning.</p>"
    ]
  }
];

